import { useMemo } from "react";
import { useSelector } from "react-redux";

import Loaders from "@stadium/ui/src/components/loaders/loaders";

import { useAuthQuery } from "@stadium/services/apollo-client";

import { fetchProductDetail } from "@graphql/queries/stores/products/fetch-detail";

import KitProductDetail from "@components/store/product-detail/kit";
import { getCommonGlobalCountryVariables } from "@helpers/store";

import { getCountry } from "@store/selectors/country";
import { getStoreCurrencyCode, getStoreNumber } from "@store/selectors/store";

import { useStoreContext } from "@components/store/provider";

import styles from "./main.module.scss";

const StoreProductDetail = ({ productSlug, productData: initialProductData }) => {
  const country = useSelector(getCountry);
  const storeCurrencyCode = useSelector(getStoreCurrencyCode);
  const storeNumber = useSelector(getStoreNumber);

  const { isGlobalCountry } = useStoreContext();

  const commonGlobalCountryVariables = getCommonGlobalCountryVariables({
    country,
    isGlobalCountry,
  });

  const variables = {
    slug: productSlug,
    currency: storeCurrencyCode,
    storeNumber,
    ...commonGlobalCountryVariables,
  };

  const { data: queriedData, loading } = useAuthQuery(fetchProductDetail, {
    variables,
    fetchPolicy: "cache-and-network",
    skip: !storeCurrencyCode,
  });

  const data = queriedData || initialProductData;

  const product = useMemo(() => data?.product, [data]);

  if (loading || !data?.product)
    return <Loaders.PageLoader wrapperClass="pageLoaderwrap min-h-100" />;

  return (
    <section className={`${styles.storePageContainer} ${styles.extraClass}`}>
      <KitProductDetail product={product} />
    </section>
  );
};

export default StoreProductDetail;
